export default function unwrap<T>(value: T | null | undefined): T {
  if (value == null) {
    throw new Error("Force-unwrapped null value.");
  }
  return value;
};

